// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610120705/js/" + chunkId + "." + {"44":"23c869b3","225":"a3605f06","481":"e6d918db","486":"32f2d7f4","770":"ca14a172"}[chunkId] + ".0.9048069402905017.chunk.js";
};